export var TwoFaActions;
(function (TwoFaActions) {
    TwoFaActions["ACTIVATE"] = "activate";
    TwoFaActions["DEACTIVATE"] = "deactivate";
})(TwoFaActions || (TwoFaActions = {}));
//# sourceMappingURL=twoFaAction.js.map